import { IGenericObject } from 'types';
import {
  DELETE_PROFILE,
  LOAD_PROFILE,
  LOAD_PROFILES,
  LOAD_PROFILE_TYPES,
  PROFILES_LOADED,
  PROFILE_DELETED,
  PROFILE_LOADED,
  PROFILE_SAVED,
  PROFILE_TYPES_LOADED,
  RESET_PROFILES,
  RESET_SELECTED_PROFILE,
  SAVE_PROFILE,
  SYNC_FAILED,
} from './actionTypes';
import {
  IDeleteProfileAction,
  IFailedSyncAction,
  IProfilesAction,
  IProfilesState,
  ISetProfileAction,
  ISetProfilesAction,
  ISetProfileTypesAction,
} from './types';

// @TODO move activities and profile types inside meta
export const initialState = {
  error: null,
  loaded: false,
  profiles: [],
  profileTypes: [],
  selectedProfile: null,
  syncing: false,
};

export const reducer = (
  state: IProfilesState = initialState,
  action: IProfilesAction
): IProfilesState => {
  switch (action.type) {
    case LOAD_PROFILE:
      return { ...state, error: null, selectedProfile: null, syncing: true };
    case DELETE_PROFILE:
    case LOAD_PROFILE_TYPES:
    case LOAD_PROFILES:
    case SAVE_PROFILE:
      return { ...state, error: null, syncing: true };
    case PROFILE_DELETED:
      return {
        ...state,
        error: null,
        profiles: state.profiles.filter(
          (profile: IGenericObject) =>
            profile.externalId !== (action as IDeleteProfileAction).payload.id
        ),
        syncing: false,
      };
    case PROFILE_LOADED:
      return {
        ...state,
        error: null,
        selectedProfile: (action as ISetProfileAction).payload,
        syncing: false,
      };
    case PROFILE_SAVED:
      return { ...state, error: null, syncing: false };
    case PROFILE_TYPES_LOADED:
      return {
        ...state,
        error: null,
        profileTypes: (action as ISetProfileTypesAction).payload,
        syncing: false,
      };
    case PROFILES_LOADED:
      return {
        ...state,
        error: null,
        profiles: (action as ISetProfilesAction).payload,
        syncing: false,
      };
    case RESET_PROFILES:
      return initialState;
    case RESET_SELECTED_PROFILE:
      return { ...state, selectedProfile: null };
    case SYNC_FAILED:
      return { ...state, error: (action as IFailedSyncAction).payload, syncing: false };
    default:
      return state;
  }
};
